import React from "react";

const SectionHeading = ({ title, subtitle, center = false, light = false }) => {
  const alignment = center ? "text-center mx-auto" : "";
  const titleColor = light ? "text-white" : "text-gray-900";
  const subtitleColor = light ? "text-gray-300" : "text-gray-600";

  return (
    <div className={`max-w-3xl ${alignment} mb-10`}>
      <h2
        className={`text-3xl md:text-4xl font-bold ${titleColor} mb-4 font-display`}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`text-lg ${subtitleColor} leading-relaxed`}>{subtitle}</p>
      )}
    </div>
  );
};

export default SectionHeading;
